// extracted by mini-css-extract-plugin
export var breadcrumb = "_1j-3";
export var breadcrumbArrow = "_1j-4";
export var breadcrumbs = "_1j-0";
export var link = "_1j-5";
export var sm = "_1j-1";
export var xs = "_1j-2";